<template>
    <div class="page home">
        <VHeader :avatar="true" :opacity="opacity" @avatar="show({ page: 'ch-account' })" style="position:fixed;transform: translate(0px);top:0px;left:0px;z-index:10" />
        <div class="page-content" :style="{ 'background-color': backgroundColor }" style="height:100%">
            <div class="div-btns" style="position: absolute;top:0px;left:0px;transform-origin:0px 0px">
                <div style="float:left;width:100%;height:80px"></div>
                <div v-if="homeBanner && homeBanner.type == 'video'" style="position:relative">
                    <img v-if="homeBanner.placeHolder" :src="homeBanner.placeHolder" style="width:100%;position:absolute;top:80px" />
                    <video :src="homeBanner.src" controls style="transform: translate(0px);width:100%">
                        <source :src="homeBanner.src" preload="metadata" type="video/mp4"></source>
                    </video>
                </div>
                <div v-if="homeBanner && homeBanner.type == 'image'">
                    <img :src="homeBanner.src" style="width:100%" />
                </div>
                <img :src="welcome" style="width:100%;display:none" />
                <!-- <img src="https://www.copperhousebar.co.uk/wp-content/uploads/2019/07/homepage_hero_img_01a@2x.jpg" style="width: 100%;" /> -->
                <div style="float:left;margin-top:-25px;width: 100%" v-if="!btnImage">
                    <p v-for="btn in menu" class="btn" @click="show(btn)" :style="{ backgroundColor: btnColor, color: btnFontColor, 'margin-top': '20px' }">{{ btn.text }}</p>
                </div>
                <div style="float:left;width: 100%;padding-bottom: 100px;" v-if="btnImage">
                    <img class="img-button" v-for="btn in menu" :src="btn.src" :style="{ width: btn.width, float: 'left' }" @click="show(btn)" @touchstart="touch(btn)" />
                </div>
                
            </div>                 
        </div>
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import Ham from '@/components/Ham.vue'
import { mapMutations, mapActions } from 'vuex'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import { pageOn } from '@/utils/pageOn.js'

export default {
    name: 'home',
    mixins: [ pageOn ],
    components: {
        VHeader,
        Ham
    },
    computed: {
        survey () { return this.$store.state.survey },
        TsCs () { return this.$store.state.TsCs },
        client_id () { return this.$store.state.client_id },
        name () { return this.$store.state.name },
        backgroundColor () { return this.$store.state.backgroundColor },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor },
        welcome () { return this.$store.state.welcome },
        adCats () { return this.$store.state.adCats },
        customer_id () { return this.$store.state.auth._id },
        customerID () { return this.$store.state.auth.id },
        menu () { return this.$store.state.menu },
        comps () { return this.$store.state.comps },
        entries () { return this.$store.state.entries },
        btnImage () { return this.$store.state.btnImage },
        man () { return this.$store.state.man },
        avatar () { return this.$store.state.avatar },
        homeBanner () { return this.$store.state.homeBanner },
        testURL () { return this.$store.state.testURL }
    },
    data () {
        return {
            on: true,
            btns: [
                { text: 'LATEST OFFERS', page: 'survey' },
                { text: 'LOYALTY CARD', page: 'ch-membership' },
                //{ text: 'BOOK NOW', page: 'book-now' },
                //{ text: 'REFER A FRIEND', page: 'refer' },
                { text: "FAQ's", page: 'faq' },
                { text: 'CONTACT US', page: 'contact-us' } 
            ],
            initial: true,
            opacity: 1
        }
    },
    mounted () {
        this.initWS();

        if ( !this.menu || this.menu.length == 0 ) {
            this.setValue({ k: 'menu', v: [ { text: 'LATEST OFFERS', page: 'survey' },
                                            { text: 'LOYALTY CARD', page: 'ch-membership' },
                                            //{ text: 'BOOK NOW', page: 'book-now' },
                                            //{ text: 'REFER A FRIEND', page: 'refer' },
                                            { text: "FAQ's", page: 'faq' },
                                            { text: 'CONTACT US', page: 'contact-us' }
                                        ] })
        }
        var scroller = this.$el.querySelector('.page-content');
            scroller.onscroll = e => {
                this.opacity = Math.max(( 50 - scroller.scrollTop ) / 50,0);
            }  
            
            const options = {
                publicKey: {
                    rp: { name: "letsreset.club" },
                    user: {
                        name: 'petera@rush.technology',
                        id: new Uint8Array('ABC123'.split('').map(c => c.charCodeAt(0))),
                        displayName: 'Peter Alderson'
                    },
                    pubKeyCredParams: [ { type: "public-key", alg: -7 } ],
                    challenge: new Uint8Array(new Array(49).fill('abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJLKLMNOPQRSTUVWZXYZ').map(c => c[parseInt(Math.random()* 62)]).join('')),
                    authenticatorSelection: { authenticatorAttachment: "platform" }
                }
            };

            return;

            setTimeout(() => { 
                window.navigator.credentials.create(options).then(PublicKeyCredential => {
                    console.log('PublicKeyCredential',PublicKeyCredential);
                    PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().then(isAvailable => {
                        console.log('isAvailable',isAvailable);
                        if ( !isAvailable ) return;



                        // .get(otherOptions)
                        // this is enroll

                    })
                }).catch(e => console.log('createOption Error',e));
            },4000);
        return;

        PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().then(isAvailable => {
            if ( !isAvailable ) return;



            // .get(otherOptions)
            // this is enroll

        })

        return;

        console.log('isAvailable',isAvailable);

        if ( !isAvailable ) return;
        /*
        const options = {
            publicKey: {
                rp: { name: "letsreset.club" },
                user: {

                },
                pubKeyCredParams: [ { type: "public-key", alg: -7 } ],
                challenge: new Array(49).fill('abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJLKLMNOPQRSTUVWZXYZ').map(c => c[parseInt(Math.random()* 62)]).join(''),
                authenticatorSelection: { authenticatorAttachment: "platform" }
            }
        };
        */
        /*
        const publicKeyCredential = await navigator.credentials.get(options);

            console.log('publicKeyCredential',publicKeyCredential);

        */


    },
    methods: {
        touch ( btn ) {
            // for iOS Active;
        },
        show ( btn ) {
            var page = btn.page;
            var campaign_id = btn.campaign_id;
            var referCampaign_id = btn.referCampaign_id || false;
            var referCampaignQty = btn.referCampaignQty || 0; 
            if ( page == 'loyalty' ) { this.setValue({ k: 'loyaltyCampaign_id', v: campaign_id }); }
            if ( page == 'survey' ) return this.getAds(campaign_id);
            if ( page == 'comp' ) return this.getComps(btn);
            if ( page == 'comps' ) return this.getComps(btn);
            if ( page == 'refer' ) {
                this.setValue({ k: 'referCampaign_id', v: referCampaign_id })
                this.setValue({ k: 'referCampaignQty', v: referCampaignQty });
            }
            this.pushPage(page);
        },
        getComps ( btn ) {

            this.setValue({ k: 'selectedCat', v: true });
            this.setValue({ k: 'ads', v: [] });

            //console.log(JSON.stringify(btn,null,1));

            WebSoc.SEND({ t: 'getComps', data: { client_id: this.client_id, customer_id: this.customer_id, customerID: this.customerID, campaign_id: btn.campaign_id } },resp => {
                if ( resp.comps ) {
                    var entries = this.entries;
                    //console.log('entries',JSON.parse(JSON.stringify(entries)));
                    resp.comps.forEach(c => c.entered = !!entries.find(e => e.ad_id == c.ad_id));
                    //console.log('comps',JSON.parse(JSON.stringify(resp.comps)));
                    
                    var adCats = this.adCats;
                    
                    var cats = resp.comps.map(ad => ad.cat).filter(c => c).filter((c,i,arr) => arr.indexOf(c) == i).sort((a,b) => adCats.indexOf(a) < adCats.indexOf(b) ? -1 : 1);
                    
                    this.setValue({ k: 'comps', v: resp.comps });

                    if ( cats.length < 2 ) {
                        this.pushPage('comps');
                    } else {
                        this.setValue({ k: 'cats', v: cats });
                        this.pushPage('cats');
                    }

                    //console.log('getComps cats',cats);

                    if ( resp.competitions && resp.comps.length == 0 ) return Alert.message('No Compitions available today !');
                    
                }
            })
        },
        getAds ( campaign_id, count = 0 ) {
            this.setValue({ k: 'comps', v: [] });
            this.setValue({ k: 'selectedCat', v: true });
            WebSoc.SEND({ t: 'getAds', data: { campaign_id, client_id: this.client_id, customer_id: this.customer_id, customerID: this.customerID, name: this.name } },resp => {
                //console.log('getAds resp',resp);
                if ( resp.response_id ) return this.setValue({ k: 'response_id', v: resp.response_id });
                if ( !resp.ads ) return;
                if ( !resp.loyalty ) {
                    //console.log('getAds',campaign_id);
                    this.setValue({ k: 'campaign_id', v: campaign_id });
                    resp.ads.forEach((page,i) => page.off = i > 0);
                    this.setValue({ k: 'takeSurvey', v: resp.ads });
                    this.pushPage('take-survey');
                    return;
                }
                if ( resp.ads.length == 0 && ++count < 5 ) return setTimeout(() => this.getAds(campaign_id,count),500);
                resp.ads.forEach(ad => ad.qr && ( ad.qrImg = '' ));
                var adCats = this.adCats;
                var cats = resp.ads.map(ad => ad.cat).filter(c => c).filter((c,i,arr) => arr.indexOf(c) == i).sort((a,b) => adCats.indexOf(a) < adCats.indexOf(b) ? -1 : 1);
                if ( cats.length < 2 ) {
                    this.setValue({ k: 'selectedCat', v: true });
                    this.pushPage('survey');
                } else {
                    this.pushPage('cats');
                    this.setValue({ k: 'cats', v: cats });
                }
                
                this.setValue({ k: 'ads', v: resp.ads });
            })
        },
        terms () {
            this.$emit('showTerms');
        },
        signOut () {
            Alert.yesno('Sign Out from this device ?',yes => {
                if ( !yes ) return;
                this.clearAuth();
                this.setPages(['home','copper']);
                location.href = 'https://copperhouse.club';
            })
        },
        initWS () {
            //console.log('initWS');
            var that = this;
            var session = false;
            var _id, id, user_id, userId, loyalty_id, loyaltyId;
            try {
                id = localStorage.id;
                _id = localStorage._id;
                user_id = localStorage.user_id;
                userId = localStorage.userId;
                loyalty_id = localStorage.loyalty_id;
                loyaltyId = localStorage.loyaltyId;
            } catch(e) {

            }
            if ( loyalty_id == 'undefined' ) loyalty_id = false;
            if ( loyaltyId == 'undefined' ) loyaltyId = false;
            
            //console.log('home route.path',this.$route.path);
            //console.log('home route.query',this.$route.query);
            /*
            console.log('Home.vue',{
                loyalty_id,
                loyaltyId
            });
            */
            
            if ( window.webpackHotUpdate ) {
                //var URL = 'ws://localhost:5555'   
                var URL = 'wss://api-v2.dev.memberstar.club'
            } else {

                if ( location.host.startsWith('dev.memberstar') ) {
                    var URL = 'wss://api-v2.dev.memberstar.club'
                    
                } else {
                    var URL = 'wss://api-v2.memberstar.club';
                }

            }



            var connectURL = URL;
            
            var host = window.location.host;

            if ( window.webpackHotUpdate ) {
                //host = 'copperhouse.club';
                //host = 'dev.memberstar.club';
                //host = 'letsreset.club';
                //host = 'thatcafe.club';
                //console.log('this.testURL',this.testURL);
                host = this.testURL;
            }

            if ( loyaltyId && loyalty_id ) { 
                connectURL += '/memberStar/member/'+host+'/'+loyalty_id+'/'+loyaltyId 
            } else {
                connectURL += '/memberStar/new/'+host+"?path="+encodeURIComponent(this.$route.path);
                //connectURL += '/memberStar/member/copperhouse.club?path='+encodeURIComponent(this.$route.path);
                //console.log('this.$route.path',this.$route.path);
                //console.log('connectURL',connectURL);
                this.pushPage('copper');
            }

            //console.log('connectURL',connectURL);

            WebSoc(connectURL,{
                onclose () {
                    //console.log('Home onclose');
                    that.initWS();
                },
                onopen ( ws ) {
                    if ( this.started ) return;
                    try {
                        var loyalty_id = localStorage.loyalty_id;
                        var loyaltyId = localStorage.loyaltyId;
                    } catch(e) {

                    } 
                    /*
                    console.log({
                        loyalty_id,
                        loyaltyId
                    });
                    */

                    //console.log('this.client_id',this.client_id);

                    if ( loyalty_id && loyaltyId ) {
                        //console.log('reAithLoyalty');
                        ws.SEND({ t: 'reAuthLoyalty', data: { loyalty_id, loyaltyId, initial: this.initial, client_id: this.client_id }},resp => {
                            //console.log('resp.success',resp.success);
                            this.initial = false;
                            if ( resp.success ) { 
                                that.setValue({ k: 'auth', v: resp.auth }) 
                            }
                        })
                    } else {
                        ws.SEND({ t: 'reAuthLoyalty', data: { initial: true, client_id: this.client_id }},() => {});
                    }
                },
                onmessage ( msg ) {
                    //console.log('onmessage',msg);
                    that.wsAction(msg);
                }  
            })

        },
        hamSelect ( page ) {
            this.on = false;
            this.pushPage(page);
            return;
            if ( page == 'terms' ) {
                this.$emit('showTerms');
            }
        },
        ...mapMutations([
            'pushPage',
            'setValue'
        ]),
        ...mapActions([
            'wsAction',
            'getScores'
        ]),
        approve () {
            this.pushPage('approve');
        }
    }
}

</script>

<style lang="scss">
.page.home {
    background-color: white;
}    
.page.home .page-content {
    .img-button:active {
        transform: scale(0.9);
    }
    h1 {
        display: none;
        width: 80%;
        margin: 40px 10%;
        text-align: center;
        line-height: 1.5;
    }
}
</style>